import "./Banner01.css";

import materials from "./../../../img/icons/materials-green.svg";
import animals from "./../../../img/icons/pet-green.svg";
import trees from "./../../../img/icons/trees-green.svg";

function Banner01() {
  return (
    <div className="Banner01 section">
      <div className="container">
        <div className="Banner01-box">
          <div className="Banner01-text">
            <p className="eyebrow green2">Our Promise </p>
            <h2>Driving a Greener Future, One Tyre at a Time</h2>
            <p>
              Tyre waste is a significant environmental challenge. At Global
              Tyres Recycling Ltd., our entire business model is built to solve
              it. By converting waste tyres back into valuable raw materials, we
              are at the forefront of the circular economy.
            </p>
          </div>

          <div className="Banner01-list">
            <div className="Banner01-list-item">
              <img src={materials} alt="" />

              <div className="Banner01-list-text">
                <h4>99% Material Recovery</h4>
                <p className="small-font">
                  From waste tyres, reducing landfill and conserving natural
                  resources.
                </p>
              </div>
            </div>

            <div className="Banner01-list-item">
              <img src={animals} alt="" />

              <div className="Banner01-list-text">
                <h4>100s of Saved Animals</h4>
                <p className="small-font">
                  We prevent waste tyres from being dumped in landfills, where
                  they can harm wildlife.
                </p>
              </div>
            </div>

            <div className="Banner01-list-item">
              <img src={trees} alt="" />

              <div className="Banner01-list-text">
                <h4>Every 1 Tonne Recycled</h4>
                <p className="small-font">
                  Creates approx. 700 kg of new rubber, reducing the need for
                  virgin rubber production.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner01;
